<template>
	<b-modal
		:visible="value"
		hide-footer
		ref="modal-view-resume"
		size="xl"
		:title="'Migración'"
		@hide="hidded"
	>
		
		<div class="container" v-if="modelInfo.id>0">
			<h4>[ID:{{modelInfo.id}}] {{modelInfo.name}}</h4>
			<b-row class="justify-content-center text-center" >
				<b-col cols="12">
					<b-alert show>
						A continuación se lista los lugares en donde se está usando la zona de operacion.
					</b-alert>
				</b-col>
			</b-row>
			<b-tabs no-fade pills card small vertical nav-class="nav-style">
				<!--<b-tab title="Rides [service Type]" active>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForTsHasServiceType"
					:columns="modelColumns"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab> ----->
				<!--- <b-tab title="Rides [supplier service Type]" >
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-3"
					:filters="filtersForTsHasSupplierServiceType"
					:columns="modelColumns"
					resource="service-types/actions/resume">
					</AjaxTable>
				</b-tab>-->
				<b-tab title="Rates plan">
					<h2>Rate plans heredables:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlans"
					:columns="modelColumnsRatePlans"
					resource="zoned-areas/actions/resume">
                        <template #cell(actions)="row">
                            <b-button size="sm" @click="openPriceRatePlan(row)">Ver precios</b-button>
                        </template>
					</AjaxTable>

					<h2>Suppliers Rate Plans:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlansSupplier"
					:columns="modelColumnsRatePlansSupplier"
					resource="zoned-areas/actions/resume">
                        <template #cell(actions)="row">
                            <b-button size="sm" @click="openPriceRatePlan(row)">Ver precios</b-button>
                        </template>
					</AjaxTable>

					<h2>Resumen Suppliers:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-rp"
					:filters="filtersForRatePlansUsedBySupplier"
					:columns="modelColumnsSupplierList"
					resource="zoned-areas/actions/resume">
					</AjaxTable>

					<h2>Sales Chanels Rate plans:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForRatePlansSalesChannel"
					:columns="modelColumnsRatePlansSalesChannel"
					resource="zoned-areas/actions/resume">
                        <template #cell(actions)="row">
                            <b-button size="sm" @click="openPriceRatePlan(row)">Ver precios</b-button>
                        </template>
					</AjaxTable>
					<h2>Resumen Canales:</h2>
					<AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-rp"
					:filters="filtersForRatePlansUsedBySalesChannel"
					:columns="modelColumnsSupplierList"
					resource="zoned-areas/actions/resume">
					</AjaxTable>
					
				</b-tab>
                <b-tab title="Promociones">
					<h2>Promociones:</h2>	
                    <AjaxTable
					permission-show="changelog.show"
					id="suppliers-index-list-2"
					:filters="filtersForPromotions"
					:columns="modelColumnsPromotions"
					resource="zoned-areas/actions/resume">
					</AjaxTable>	
				</b-tab>
			</b-tabs>
		</div>

		<hr>
		<b-modal ref="pricesRatePlan" size="xl">
            <div class="container">
                <div class="table-container">
                    <b-row>
						<b-col>
							<span v-if="rp.table.body.length>0">Mostrando {{(rp.pagination.perPage>rp.table.body.length)?rp.table.body.length:rp.pagination.perPage}} de {{rp.table.body.length}} registros </span>
						</b-col>
						<b-col> 
							<b-pagination 
							class="float-right"
							v-model="rp.pagination.currentPage"
							:total-rows="rp.table.body.length"
							:per-page="rp.pagination.perPage"
							aria-controls="my-table"
							>
							</b-pagination>
						</b-col>
					</b-row>
                    <b-table  
                        class="table-responsive"
                        show-empty
                        hover  
                        :items="rp.table.body" 
                        :fields="rp.table.header"
                        id="my-table" 
                        :current-page="rp.pagination.currentPage" 
                        :per-page="rp.pagination.perPage">
                     </b-table>
                </div>
            </div>
        </b-modal>
	</b-modal>
</template>

<script>
import api from '../../../../api.js'
import AjaxTable from "@/components/helpers/AjaxTable.vue";
export default {
    name:"ResumeZonedArea",
	props: {
		value:Boolean
	},
	components: {
		AjaxTable
	},
	data() {
		const defaultModelInfo = {
			id: -1,
			code: "",
			name: "",
		};
		return {
			modelId:-1,
			modelInfo:{...defaultModelInfo},
			loading:false,
			fromServiceId: {value:-1,text:""},
			toServiceId: {value:-1,text:""},
			modelColumnsRatePlansSalesChannel:[
				{key:'id',label:'id'},
				{key:'sales_channel.name',label:'Canal de venta'},
                {key:'name',label:'Nombre ratePlan'},
				{key:'zoned_area.name',label:'Zona de operacion'},
                {key:'supplier_zoned_area.name',label:'Zona de operacion[Supplier]'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
                {key:"actions",label:'actions'}
			],
			modelColumnsRatePlansSupplier:[
				{key:'id',label:'id'},
				{key:'supplier.name',label:'Supplier'},
                 {key:'name',label:'Nombre ratePlan'},
				{key:'zoned_area.name',label:'Zona de operacion'},
                {key:'supplier_zoned_area.name',label:'Zona de operacion[Supplier]'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
                {key:"actions",label:'actions'}
			],
			modelColumnsRatePlans:[
				{key:'id',label:'id'},
                 {key:'name',label:'Nombre ratePlan'},
				{key:'zoned_area.name',label:'Zona de operacion'},
                {key:'supplier_zoned_area.name',label:'Zona de operacion[Supplier]'},
				{key:'startDate',label:'Start date'},
				{key:'endDate',label:'endDate'},
				{key:'status',label:'Status'},
                {key:"actions",label:'actions'}
			],
            modelColumnsSupplierList:[
				{key:'id',label:'Id'},
				{key:'name',label:'Name'},			
			],
            modelColumnsPromotions:[
                {key:'id',label:'Id'},
				{key:'name',label:'Name'},	
                {key:'supplier.name',label:'Supplier'},	
                {key:'bookingWindowText',label:"bookingWindow"},
                {key:'travelWindowText',label:"travelWindow"},
                {key:'assignedWindowText',label:"assignedWindow"},
                {key:'description',label:"Descripción"},
                {key:'status',label:"Status"}
            ],
            rp:{
                pagination:{
                    currentPage:1,
                    perPage:50
                },
                table:{
					body:[],
					header:[]
				},
            }
		};
	},
	computed: {
		filters(){
			return {zonedAreaId:this.modelId}
		},
		filtersForRatePlans(){
			return {...this.filters,...{resource:"ratePlans"}}
		},
		filtersForRatePlansSupplier(){
			return {...this.filters,...{resource:"ratePlansSupplier"}}
		},
        filtersForRatePlansSalesChannel(){
			return {...this.filters,...{resource:"ratePlansSalesChannel"}}
		},
        filtersForRatePlansUsedBySupplier(){
            return {...this.filters,...{resource:"ratePlansUsedBySupplier"}}
        },
        filtersForRatePlansUsedBySalesChannel(){
            return {...this.filters,...{resource:"ratePlansUsedBySalesChannel"}}
        },
        filtersForPromotions(){
            return {...this.filters,...{resource:"promotions"}}
        },

	},
	methods: {
		fetchModel() {
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/zoned-areas/${this.modelId}`)
					.then(res => {
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view-resume"].show();
			this.fetchModel();
		},
		hidded(){
			this.$emit("closed");
		},
        getPricesbyRatePlan(_filters){
                
				return api(this).get(`/reports/rates`,{
					params:{
						filters:_filters
					}
				}).then((res) => {
					this.rp.table.body = res.data.body
                    
				}).catch(error => {
					this.$root.handleRequestError(error)
				})

			},
            openPriceRatePlan(row){
                let _filters = {
					suppliersSelected:[],
					salesChannelsSelected:[],
					pointOfSalesSelected:[],
					date:null,
					zonedAreasSelected:[],
                    type:"byRatePlanId",
                    ratePlanSelected:row.item.id
				};
                this.getPricesbyRatePlan(_filters)
                .then(()=>{
                    this.$refs['pricesRatePlan'].show();
                })
            }
	},
	mounted() {
		
	}
};
</script>

<style></style>
